$ = require 'jquery'
Alerts = require 'views/lib/alerts'
ApiAjax = require 'network/api-ajax'
Auth = require 'db/auth'
Browser = require 'lib/browser'
Controller = require 'controller'
Dialog = require 'views/lib/dialog'
Keyboard = require 'lib/keyboard'
Keys = require 'data/keys'
Layout = require 'views/lib/layout'
PopOver = require 'views/lib/pop-over'
SidebarState = require 'view-models/sidebar-state'
Util = require 'lib/util'
_ = require 'underscore'
globalClickHandler = require 'views/internal/global-click-handler'
track = require 'debug/track'

# We don't officially support any browser that doesn't have
# requestAnimationFrame. But... we had one very nice person
# write in who was using Opera for Linux (latest version was
# released in 2011, what). It doesn't hurt us to polyfill
# here, and if we don't then dinosaur people will just see
# a big blank Trello.
injectRequestAnimationFramePolyfill = ->
  fns = {}
  timeout = null
  animationFrameIndex = 0

  performEnqueuedFunctions = ->
    for own id, fn of fns
      fn()
    timeout = null
    fns = {}
    return

  window.requestAnimationFrame = (fn) ->
    id = animationFrameIndex++
    if !timeout?
      timeout = setTimeout performEnqueuedFunctions
    fns[id] = fn
    return id

  window.cancelAnimationFrame = (id) ->
    delete fns[id]
    return

  return

$(document).ready( ->
  $('meta[name=apple-itunes-app]').attr 'content', "app-id=461504587, app-argument=#{location.href}"

  if 'requestAnimationFrame' not of window
    injectRequestAnimationFramePolyfill()

  PopOver.init()

  Dialog.init()

  # Calculate window size and reposition popover

  window.orientationchange = -> Dialog.calcPos()

  Browser.detectCustomWebkitScrollbars()

  # Adds the dataTransfer property to jQuery so we can get HTML5 drag/drop file uploads to work
  $.event.props.push('dataTransfer')
  # Adds the detail property so we can get data attached to custom events
  $.event.props.push('detail')

  # Header tracking
  trackClick = (selector, category, action, label) ->
    $(document).on 'click', selector, (e) ->
      args = for v in [category, action, label] when v?
        if _.isFunction(v)
          v.call @, e
        else
          v

      track(args...)

  trackClick('.js-home-via-logo', "Header", "Logo", "Home")
  trackClick('.header-signup', "Header", "Sign Up")

  $(document).on 'click', '.js-resend-confirmation-email', _.throttle =>
    ApiAjax
      type: 'POST'
      url: '/resendValidate'
      data:
        email: Auth.me().get('email')
      success: ->
        Alerts.flash('email sent', 'confirm')
  , 60000

  # Close and cancel stuff

  $windowOverlay = $('.window-overlay')
  $windowOverlay.click (e) ->
    # Do not try to intercept right or middle buttons, see https://trello.com/c/ctIopcqw
    if e.button > 0
      return

    # if one clicks inside a dummy a tag, stop propagating the event
    $aTarget = $(e.target).closest('a')
    if $aTarget.length > 0 && $aTarget.attr('href') == '#'
      Util.stopPropagation(e)
      return

    # if it's the focus dummy, don't do anything
    if $(e.target).is('a.focus-dummy') || $(e.target).hasClass('checkbox')
      return

    # otherwise hide the popover if visible
    if PopOver.isVisible
      PopOver.hide()
      return

    # then check if the person is editing something or writing a comment
    if Layout.isEditing()
      Layout.cancelEdits()
      return

    # then check if they simply clicked somewhere on the actual window
    if e.target != $windowOverlay[0]
      return

    # …now we know they clicked off the window and they aren't doing anything,
    # so we can close the dialog.
    Dialog.hide()

    return


  $(document).on 'click', (e) ->
    if $(e.target).closest('.js-react-root').length
      return

    globalClickHandler(e)

  # Close all on esc

  $(document).on 'keyup', (e) ->
    key = Keyboard.getKey(e)
    if key == Keys.Escape
      e.preventDefault()
      board = Controller.getCurrentBoard()
      SidebarState.hideUnpinnedSidebar()

      if Layout.isEditing()
        Layout.cancelEdits()
      else if $('.new-comment').hasClass('focus')
        $('.new-comment').removeClass('focus').find('textarea').blur()
      else
        $('input').blur()
        $('textarea').blur()

  # Disallow dragging of anything that isn't a .ui-draggable,
  # so we don't accidentally trigger our drag/drop handlers
  $(document).on 'dragstart', (e) ->
    return $(e.target).closest('.ui-draggable, .js-draggable, [draggable="true"]').length > 0

  # Track if they're using FluidApp
  if window.fluid?
    track('FluidApp')
)



// WEBPACK FOOTER //
// ./app/scripts/init/doc-init.coffee